<template>
  <div
    class="w-full bg-light-purple-100 flex justify-center overflow-auto py-6"
    style="height: calc(100vh - 4.5rem)"
  >
    <div class="bg-pure-white rounded-3xl w-200 h-min relative">
      <div
        class="flex items-center gap-4 w-full pt-5 px-10 border-b border-grey-200"
      >
        <button
          class="border-b-4 outline-none w-full text-center"
          :class="
            tab === 'profile' ? 'border-light-purple' : 'border-transparent'
          "
          @click="setTab('profile')"
        >
          <BlTextSubtitle2 text="Profile" />
        </button>
        <button
          class="border-b-4 outline-none w-full text-center"
          :class="
            tab === 'session' ? 'border-light-purple' : 'border-transparent'
          "
          @click="setTab('session')"
        >
          <BlTextSubtitle2 text="Session history" />
        </button>
      </div>
      <TabProfile v-if="tab === 'profile'" />
      <TabSession
        v-if="tab === 'session'"
        description="Here is detailed information about your session history."
        basePath="/profile?tab=session"
        :userId="Number(currentUser.id)"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BlTextSubtitle2 from "../BlTextSubtitle2.vue";
import TabProfile from "./TabProfile.vue";
import TabSession from "./TabSession.vue";

export default {
  name: "Profile",
  components: { BlTextSubtitle2, TabProfile, TabSession },
  data() {
    return {
      tab: "profile", // profile | session
      haha: ""
    };
  },
  computed: {
    ...mapGetters(["currentUser"])
  },
  mounted() {
    const query = this.$route.query;
    this.tab = query.tab ? query.tab : "profile";
  },
  destroyed() {
    const app = document.getElementById("app");
    if (app) app.scroll({ top: 0, left: 0 });
  },
  methods: {
    setTab(val) {
      this.tab = val;
      this.$router.push(`/profile?tab=${val}`);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/profile/Profile.vue